import { SUPPORTED_LNGS } from '@ingenico/util-i18n-config';
import { STANDALONE_LANGUAGE_CONST } from '../constants/standaloneLanguage.const';

export abstract class StandaloneLanguageService {
  static getAvailableLanguages(): string[] {
    return Object.values(SUPPORTED_LNGS);
  }

  static getSessionLanguage(): string | undefined {
    try {
      const stored = localStorage.getItem(STANDALONE_LANGUAGE_CONST.storage.languageOverride);
      return stored && Object.values(SUPPORTED_LNGS).includes(stored) ? stored : undefined;
    } catch {
      return undefined;
    }
  }

  static setSessionLanguage(language: string): void {
    try {
      localStorage.setItem(STANDALONE_LANGUAGE_CONST.storage.languageOverride, language);
    } catch {
      // Ignore storage access failures.
    }
  }
}
